import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import { services } from '@orionprotocol/sdk';
import './styles/index.css';
import 'tippy.js/dist/tippy.css';
import { Governance } from '../pages';
import {
  getAppChainId,
  // getPoolsConfig,
  getWalletAddress,
} from '../shared/redux/selectors';
import './App.scss';
import { useLumia } from '../shared/context';
import { userSlice } from '../shared/redux/slices';
import { Header } from '../widgets/Header';
import { Footer } from '../widgets/Footer';
// import { TopBanner } from '../widgets/Header/TopBanner';
import { Bridge } from '../pages/Bridge';
import { Swap } from '../pages/Swap';
// import { Metrics } from '../pages/Metrics';
// import { GovernanceV2 } from '../pages/GovernanceV2';

export function App(): JSX.Element {
  const dispatch = useDispatch();
  const appChainId = useSelector(getAppChainId);
  const walletAddress = useSelector(getWalletAddress);
  // const poolsConfig = useSelector(getPoolsConfig);
  const { availableUnits, activeUnit } = useLumia();

  // Updating lock balances from all networks
  useEffect(() => {
    if (appChainId !== undefined && walletAddress !== undefined && activeUnit) {
      dispatch(
        userSlice.actions.setBalances({
          data: {},
          chainId: appChainId,
        }),
      );
      activeUnit.aggregator.ws.subscribe(
        services.aggregator.ws.SubscriptionType.ADDRESS_UPDATES_SUBSCRIBE,
        {
          payload: walletAddress,
          callback: (data) => {
            dispatch(
              userSlice.actions.setBalances({
                data: data.balances,
                chainId: appChainId,
              }),
            );
          },
        },
      );
    }
    return () => {
      if (activeUnit !== undefined && walletAddress !== undefined) {
        activeUnit.aggregator.ws.unsubscribe(walletAddress, 'SPOT');
      }
    };
  }, [walletAddress, dispatch, appChainId, activeUnit, availableUnits]);

  return (
    <>
      {/* <TopBanner /> */}
      <div className="App">
        <Header />
        <div className="main">
          <Routes>
            {/* <Route path="/governance/*" element={<GovernanceV2 />} /> */}
            {/* <Route path="/governance/*" element={<Governance />} /> */}
            {/* <Route path="/pools/*" element={<PoolsV2 />} /> */}
            {/* <Route path="/bridge" element={<Bridge />} /> */}
            <Route path="/swap" element={<Swap />} />
            {/* <Route path="/metrics" element={<Metrics />} /> */}
            <Route path="*" element={<Navigate to="/swap" />} />
          </Routes>
        </div>
        <Footer />
        <div id="dialog" />
      </div>
    </>
  );
}
